<template>
    <div class="PrivacyPolicy">
        <menuBox :step="4"></menuBox>

        <div class="privacy-box">Privacy Policy</div>

        <div class="serice-box">
            <div class="serice">
                <div class="search-box">
                    <div class="serch-title">All Service</div>

                    <div class="sea-item">
                        1. Comprehensive Marketing Solutions
                        <img src="../assets/icon-1.png" alt="">
                    </div>
                    <div class="sea-item">
                        2. Tailored Advertising Campaigns
                        <img src="../assets/icon-1.png" alt="">
                    </div>
                    <div class="sea-item">
                        3. Innovative Brand Strategies
                        <img src="../assets/icon-1.png" alt="">
                    </div>
                    <div class="sea-item">
                        4. Targeted Audience Engagement
                        <img src="../assets/icon-1.png" alt="">
                    </div>
                    <div class="sea-item">
                        5. Dynamic Social Media Management
                        <img src="../assets/icon-1.png" alt="">
                    </div>
                </div>
                <img src="../assets/privacy-1.png" alt="">
            </div>
            <div class="finan-box">
                <img src="../assets/privacy-2.png" alt="">
                <div class="finan-text">
                    <div class="text-1">Our Assurance:</div>
                    <div class="text-2">We guarantee strict compliance with relevant privacy laws and regulations to safeguard your personal information and uphold your rights.</div>
                    <div class="text-3">Your Privacy Rights:</div>
                    <div class="text-4">You have the right to access, correct, or delete your personal information at any time. If you have any related requests or inquiries, please contact us.</div>
                </div>
            </div>
        </div>

        <div class="anytime">
            <div class="title">Feel Free to Write us Anytime </div>
            <div class="anytime-box">
                <div class="left-box">
                    <div class="left-text-1">CONTACT US</div>
                    <div class="left-text-2">Feel free to write us anytime</div>
                    <div class="left-text-3">Horem ipsum dolor cosetetuer adc lorem ipsumHorem adc lorem ipsum Horem ipsum dolor cosetetuer adc</div>
                    <div class="img-box">
                        <img src="../assets/icon-2.png" alt="">
                        (917) 814 - 3527
                    </div>
                    <div class="img-box">
                        <img src="../assets/icon-3.png" alt="">
                        henry@hami-tech.com
                    </div>
                    <div class="img-box">
                        <img src="../assets/icon-4.png" alt="">
                        FLAT/RM A 12/F ZJ 300 300LOCKHART RD WAN CHAIHONG KONG
                    </div>
                </div>
                <div class="right-box">
                    <input type="text" placeholder="Your Name" class="input-text input-top">
                    <input type="text" placeholder="Email Address" class="input-text">
                    <textarea rows="10" cols="30" placeholder="Write a Message" class="input-text textarea-box"></textarea>
                    <div class="send-btn">Send Message</div>
                </div>
            </div>
        </div>
        <footerBox :step="4"></footerBox>
    </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>

<style lang="less" scoped>
.privacy-box {
    padding: 116px 360px;
    background-color: #5B2CD4;
    font-weight: 500;
    font-size: 48px;
    color: #FFFFFF;
}

.serice-box {
    padding: 125px 360px;

    .serice {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .search-box {
            width: 401px;
            height: 529px;
            background: #5B2CD4;
            border-radius: 40px 40px 40px 40px;
            overflow: hidden;

            .serch-title {
                padding: 0px 28px;
                height: 79px;
                background: #1E1729;
                font-weight: 500;
                font-size: 28px;
                color: #FFFFFF;
                line-height: 79px;
            }

            .sea-item {
                width: 301px;
                height: 62px;
                background: #FFFFFF;
                border-radius: 20px 20px 20px 20px;
                opacity: 0.94;
                font-weight: 400;
                font-size: 20px;
                color: #71747A;
                padding: 0px 20px;
                line-height: 62px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;
                margin-left: 30px;

                img {
                    width: 22px;
                }
            }
        }

        img {
            width: 769px;
        }
    }

    .finan-box {
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
            width: 401px;
        }

        .finan-text {
            width: 769px;
            text-align: left;

            .text-1 {
                font-weight: bold;
                font-size: 48px;
                color: #333333;
            }

            .text-2 {
                font-weight: 400;
                font-size: 20px;
                color: #333333;
                margin-top: 31px;
            }

            .text-3 {
                font-weight: bold;
                font-size: 48px;
                color: #582ACC;
                margin-top: 40px;
            }

            .text-4 {
                font-weight: 400;
                font-size: 20px;
                color: #333333;
                margin-top: 31px;
            }
        }
    }
}

.anytime {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 150px 0px;

    .sbtitle {
        font-weight: 500;
        font-size: 24px;
        color: #6434E0;
    }

    .title {
        font-weight: bold;
        font-size: 46px;
        color: #333333;
        margin-top: 20px;
    }

    .anytime-box {
        width: 1172px;
        height: 596px;
        background: url(../assets/privacy-3.png);
        margin-top: 80px;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;

        .left-box {
            padding: 38px 24px;
            width: 350px;

            .left-text-1 {
                font-weight: 400;
                font-size: 24px;
                color: #FFFFFF;
            }

            .left-text-2 {
                font-weight: bold;
                font-size: 32px;
                color: #FFFFFF;
                margin-top: 20px;
            }

            .left-text-3 {
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                border-bottom: 1px solid rgba(255, 255, 255, 0.26);
                padding-bottom: 23px;
                margin-top: 10px;
            }

            .img-box {
                display: flex;
                font-weight: 500;
                font-size: 20px;
                color: #FFFFFF;
                margin-top: 50px;

                img {
                    width: 40px;
                    height: 40px;
                    margin-right: 10px;
                }
            }
        }

        .right-box {
            padding: 37px;
            width: 700px;

            .input-text {
                width: 660px;
                height: 80px;
                background: #FFFFFF;
                border-radius: 20px 20px 20px 20px;
                padding: 0px 30px;
                margin-top: 24px;
                border: none;
            }

            .input-top {
                margin-top: 42px;
            }

            .textarea-box {
                height: 102px;
                padding: 30px;
            }

            .send-btn {
                width: 192px;
                height: 60px;
                background: #5F2DDE;
                border-radius: 20px 20px 20px 20px;
                margin-top: 24px;
                font-weight: 500;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 60px;
                text-align: center;
            }
        }
    }
}
</style>
